export default "__VITE_ASSET__BMNv1zUz__"